/* eslint-disable no-bitwise */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { InjuryGroupsInterface } from '@interfaces/injuries.interface';

import { BaseComponent } from '../base.component';

import { InjuryService } from '@/services/injury.service';


@Component({
    selector: 'app-grouped-tournament-injuries',
    templateUrl: './grouped-tournament-injuries.component.html',
})
export class GroupedTournamentInjuriesComponent extends BaseComponent implements OnDestroy, OnInit {
    @Input()
    public sportId: number;

    @Input()
    public sportName: string;

    @Input()
    public subTournamentId: number;

    @Input()
    public seasonId: number | null = null;

    @Input()
    public weekIds: number[] = [];

    @Input()
    public splitByGroup: boolean = true;

    public subscriber: Subscription;
    public injuryGroups: InjuryGroupsInterface | null = null;

    public constructor(
        private injuryService: InjuryService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.load(true);
    }

    public ngOnDestroy(): void {
        this.subscriber.unsubscribe();
    }

    private async load(loadLatestWeekInjuries: boolean = false): Promise<void> {
        const data = await this.injuryService.getInjuryGroups(
            this.seasonId,
            this.subTournamentId,
            this.weekIds,
            loadLatestWeekInjuries,
        );

        this.subscriber = data.subscribe((data: InjuryGroupsInterface) => {
            this.weekIds = data.week_ids;
            this.injuryGroups = data;
        });
    }

    public toggleWeek(weekId: number): void {
        window.requestAnimationFrame((): void => {
            const position = this.weekIds.indexOf(weekId);
            if (~position) {
                this.weekIds.splice(position, 1);
            } else {
                this.weekIds.push(weekId);
            }

            this.load();
        });
    }

    public weekOpened(weekId: number): boolean {
        const position = this.weekIds.indexOf(weekId);
        return Boolean(~position);
    }
}
